import { render, staticRenderFns } from "./ChipStatus.vue?vue&type=template&id=15d95318"
import script from "./ChipStatus.vue?vue&type=script&lang=ts"
export * from "./ChipStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports